export default {
    api: {
        url: 'https://api.bakerindiaapp.com/api/v1/',
        mode: 'cors'
    },
}